const HOUR_IN_SECONDS = 60 * 60;
const DAY_IN_SECONDS = 24 * HOUR_IN_SECONDS;

export const TIME_BASED_EXPIRATION_OPTIONS = Object.freeze([
  { label: "in 1 hour", retentionLabel: "1 hour", hours: 1, seconds: HOUR_IN_SECONDS },
  { label: "in 1 day", retentionLabel: "1 day", hours: 24, seconds: DAY_IN_SECONDS },
  { label: "in 1 week", retentionLabel: "1 week", hours: 168, seconds: 7 * DAY_IN_SECONDS },
  { label: "in 1 month", retentionLabel: "1 month", hours: 720, seconds: 30 * DAY_IN_SECONDS },
  { label: "in 3 months", retentionLabel: "3 months", hours: 2160, seconds: 90 * DAY_IN_SECONDS },
  { label: "in 6 months", retentionLabel: "6 months", hours: 4320, seconds: 180 * DAY_IN_SECONDS },
  { label: "in 1 year", retentionLabel: "1 year", hours: 8760, seconds: 365 * DAY_IN_SECONDS },
  { label: "in 2 years", retentionLabel: "2 years", hours: 17520, seconds: 730 * DAY_IN_SECONDS },
]);

export const REQUEST_EXPIRATION_OPTIONS = Object.freeze([
  { label: "Never", value: null },
  ...TIME_BASED_EXPIRATION_OPTIONS.map(({ label, hours }) => ({ label, value: hours })),
]);

export const REQUEST_EXPIRATION_OPTION_HOURS = Object.freeze(TIME_BASED_EXPIRATION_OPTIONS.map(({ hours }) => hours));

export const expirationLabelForSeconds = (seconds) => {
  const option = TIME_BASED_EXPIRATION_OPTIONS.find(({ seconds: optionSeconds }) => optionSeconds === seconds);
  return option ? option.retentionLabel : `${seconds} seconds`;
};
